var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "row d-flex justify-content-between align-items-start" },
        [
          _c("vs-list-item", {
            staticClass: "col-10 ml-2",
            attrs: {
              title: _vm.getSelectedElement.owner,
              subtitle: "Propietario",
              "data-cy": "file-owner"
            }
          }),
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value:
                    _vm.userPermissions.totalControl === 0
                      ? "No puede editar porque no es propietario"
                      : "Editar propietario",
                  expression:
                    "userPermissions.totalControl === 0\n        ? 'No puede editar porque no es propietario'\n        : 'Editar propietario'"
                }
              ],
              staticClass: "col-1 p-0 m-0",
              class: {
                "cursor-not-allowed": _vm.userPermissions.totalControl === 0
              },
              attrs: {
                "data-cy": "edit-owner",
                variant: "ligth",
                disabled: _vm.userPermissions.totalControl === 0
              },
              on: {
                click: function($event) {
                  _vm.showModal = true
                }
              }
            },
            [
              _c("font-awesome-icon", {
                staticClass: "mt-4",
                attrs: { icon: "edit" }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            "no-close-on-backdrop": true,
            title: "Cambiar propietario",
            "hide-footer": "",
            centered: ""
          },
          model: {
            value: _vm.showModal,
            callback: function($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal"
          }
        },
        [
          _c("ChangeOwnerModal", {
            on: {
              close: function($event) {
                _vm.showModal = false
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }